import { LocationVarKey } from "@swivl-mono/types";

import { IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.HasCreateLeadForMovingTrucks,
  LocationVarKey.MoveMovingTruck1,
  LocationVarKey.MoveMovingTruck2
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Moving Truck
      </PageHeader>

      <SwitchRow {...page} keyName={LocationVarKey.HasCreateLeadForMovingTrucks} label="Create Leads for Moving Truck Inquiries" />

      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.MoveMovingTruck1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.MoveMovingTruck2}
        enableSwitchVar={LocationVarKey.MoveMovingTruck2Enabled}
      />
    </>
  );
}
